import { FormsModule, ReactiveFormsModule } from "@angular/forms";

import { CommonModule } from "@angular/common";
import { HttpClientModule } from "@angular/common/http";
import { NgModule } from "@angular/core";
import { FlexLayoutModule } from "@angular/flex-layout";
import { AlulaReceiverInputComponent } from "@app/entity/components/company-settings/central-stations/alula-receiver-input/alula-receiver-input.component";
import { AlulaReceiversGroupAddComponent } from "@app/entity/components/company-settings/central-stations/alula-receivers-group-add/alula-receivers-group-add.component";
import { DealerBrandingManagementComponent } from "@app/entity/components/dealer-branding/dealer-branding-management/dealer-branding-management.component";
import { EditLockoutScreenComponent } from "@app/entity/components/dealer-branding/edit-lockout-screen/edit-lockout-screen.component";
import { PreviewCustomScreenComponent } from "@app/entity/components/dealer-branding/previewcustomscreen/preview-custom-screen.component";
import { ExportCsvButtonModule } from "@app/export-csv-button/export-csv-button.module";
import { MonitoringServicesFormComponent } from "@app/project/components/security/monitoring-services-form/monitoring-services-form.component";
import { ClareSliderComponent } from "@app/shared/components/clare-slider/clare-slider.component";
import { ClareAlertComponent } from "./components/clare-alert/clare-alert.component";
import { ClareButtonToggleComponent } from "./components/clare-button-toggle/clare-button-toggle.component";
import { ClareCheckboxComponent } from "./components/clare-checkbox/clare-checkbox.component";
import { ClareControllerInputConfirmationComponent } from "./components/clare-controller-input-confirmation/clare-controller-input-confirmation.component";
import { ClareControllerInputComponent } from "./components/clare-controller-input/clare-controller-input.component";
import { ClareCustomTableComponent } from "./components/clare-custom-table/clare-custom-table.component";
import { ClareDialogComponent } from "./components/clare-dialog/clare-dialog.component";
import { ClareListHeaderComponent } from "./components/clare-list-header/clare-list-header.component";
import { ClareListViewComponent } from "./components/clare-list-view/clare-list-view.component";
import { ClareListComponent } from "./components/clare-list/clare-list.component";
import { ClareRxDialogComponent } from "./components/clare-rx-dialog/clare-rx-dialog.component";
import { ClareSearchComponent } from "./components/clare-search/clare-search.component";
import { ClareSelectComponent } from "./components/clare-select/clare-select.component";
import { ClareSignalStrengthComponent } from "./components/clare-signal-strength/clare-signal-strength.component";
import { ClareSlidetoggleComponent } from "./components/clare-slidetoggle/clare-slidetoggle.component";
import { ClareSpinnerComponent } from "./components/clare-spinner/clare-spinner.component";
import { ClareStatusFilterComponent } from "./components/clare-status-filter/clare-status-filter.component";
import { ClareStatusIndicatorComponent } from "./components/clare-status-indicator/clare-status-indicator.component";
import { ClareTextInputComponent } from "./components/clare-text-input/clare-text-input.component";
import { CreateLockoutFilesComponent } from "./components/create-lockout/create-lockout-files.component";
import { DashboardWidgetComponent } from "./components/dashboard-widget/dashboard-widget.component";
import { DatePickerComponent } from "./components/date-picker/date-picker.component";
import { DeleteConfirmationModule } from "./components/delete-confirmation/delete-confirmation.module";
import { DisplayAddressComponent } from "./components/display-address/display-address.component";
import { DisplayCustomerInfoComponent } from "./components/display-customer-info/display-customer-info.component";
import { EmailUnderDifferentDealerComponent } from "./components/email-under-different-dealer-dialog/email-under-different-dealer-dialog.component";
import { EmbeddedMobileHeaderComponent } from "./components/embedded-mobile-header/embedded-mobile-header.component";
import { FlyoutMenuComponent } from "./components/flyout-menu/flyout-menu.component";
import { GenericHeaderComponent } from "./components/generic-header/generic-header.component";
import { GenericInputContainerComponent } from "./components/generic-input-container/generic-input-container.component";
import { InfoBannerComponent } from "./components/info-banner/info-banner.component";
import { ListFilterCheckboxGroupComponent } from "./components/list-filter-checkbox-group/list-filter-checkbox-group.component";
import { MainContentContainerComponent } from "./components/main-content-container/main-content-container.component";
import { MessageBoxComponent } from "./components/message-box/message-box.component";
import { PhoneInputComponent } from "./components/phone-input/phone-input.component";
import { TableCustomActionCollapsedComponent } from "./components/table-custom-action-collapsed/table-custom-action-collapsed.component";
import { TableCustomActionContainerComponent } from "./components/table-custom-action-container/table-custom-action-container.component";
import { TableCustomActionOverflowComponent } from "./components/table-custom-action-overflow/table-custom-action-overflow.component";
import { TableCustomActionComponent } from "./components/table-custom-action/table-custom-action.component";
import { UserExistsDialogComponent } from "./components/user-exists-dialog/user-exists-dialog.component";
import { FirebaseDatabaseService } from "./databases/firebase-websocket.database";
import { RalinkDatabaseService } from "./databases/ralink.database";
import { AutocompleteDirective } from "./directives/autocomplete.directive";
import { LetDirective } from "./directives/let-var.directive";
import { LowercaseInpDirective } from "./directives/lowercase-inp.directive";
import { MacInpDirective } from "./directives/mac-inp.directive";
import { UppercaseInpDirective } from "./directives/uppercase-inp.directive";
import { MaterialModule } from "./material.module";
import { ArrayFilterPipe } from "./pipes/array-filter/array-filter.pipe";
import { LastStepBtnPipe } from "./pipes/last-step-btn.pipe";
import { OccupationStatusPipe } from "./pipes/occupation-status/occupation-status.pipe";
import { FormatPhonePipe } from "./resources/phone-formatter.pipe";
import { ValidationMessageComponent } from "./validation-message/validation-message.component";

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        FlexLayoutModule,
        ReactiveFormsModule,
        MaterialModule,
        DeleteConfirmationModule,
        HttpClientModule,
        ExportCsvButtonModule,
    ],
    declarations: [
        ValidationMessageComponent,
        ClareCustomTableComponent,
        DashboardWidgetComponent,
        PhoneInputComponent,
        ClareControllerInputComponent,
        ClareSearchComponent,
        ClareListComponent,
        DisplayAddressComponent,
        DisplayCustomerInfoComponent,
        ClareStatusIndicatorComponent,
        ClareSpinnerComponent,
        ClareControllerInputConfirmationComponent,
        UserExistsDialogComponent,
        EmailUnderDifferentDealerComponent,
        FormatPhonePipe,
        ClareSlidetoggleComponent,
        ClareButtonToggleComponent,
        ClareCheckboxComponent,
        GenericInputContainerComponent,
        ClareSelectComponent,
        ClareSliderComponent,
        ClareAlertComponent,
        ClareDialogComponent,
        ClareTextInputComponent,
        ClareSignalStrengthComponent,
        FlyoutMenuComponent,
        EmbeddedMobileHeaderComponent,
        LowercaseInpDirective,
        AutocompleteDirective,
        UppercaseInpDirective,
        MacInpDirective,
        TableCustomActionComponent,
        ClareListViewComponent,
        ClareListHeaderComponent,
        ClareStatusFilterComponent,
        TableCustomActionContainerComponent,
        TableCustomActionOverflowComponent,
        TableCustomActionCollapsedComponent,
        LetDirective,
        ClareRxDialogComponent,
        ArrayFilterPipe,
        DatePickerComponent,
        OccupationStatusPipe,
        CreateLockoutFilesComponent,
        EditLockoutScreenComponent,
        DealerBrandingManagementComponent,
        PreviewCustomScreenComponent,
        MonitoringServicesFormComponent,
        MessageBoxComponent,
        MainContentContainerComponent,
        ListFilterCheckboxGroupComponent,
        GenericHeaderComponent,
        InfoBannerComponent,
        LastStepBtnPipe,
        AlulaReceiversGroupAddComponent,
        AlulaReceiverInputComponent,
    ],
    exports: [
        MaterialModule,
        ExportCsvButtonModule,
        ValidationMessageComponent,
        ClareCustomTableComponent,
        DashboardWidgetComponent,
        PhoneInputComponent,
        ClareControllerInputComponent,
        ClareSearchComponent,
        ClareListComponent,
        DisplayAddressComponent,
        DisplayCustomerInfoComponent,
        ClareStatusIndicatorComponent,
        ClareSpinnerComponent,
        EmailUnderDifferentDealerComponent,
        GenericInputContainerComponent,
        ClareSliderComponent,
        ClareAlertComponent,
        FormatPhonePipe,
        ClareTextInputComponent,
        TableCustomActionComponent,
        CommonModule,
        FlexLayoutModule,
        HttpClientModule,
        ClareSpinnerComponent,
        ClareSignalStrengthComponent,
        FlyoutMenuComponent,
        EmbeddedMobileHeaderComponent,
        LowercaseInpDirective,
        AutocompleteDirective,
        UppercaseInpDirective,
        MacInpDirective,
        ClareListViewComponent,
        LetDirective,
        ClareRxDialogComponent,
        DatePickerComponent,
        ArrayFilterPipe,
        OccupationStatusPipe,
        LastStepBtnPipe,
        CreateLockoutFilesComponent,
        EditLockoutScreenComponent,
        DealerBrandingManagementComponent,
        PreviewCustomScreenComponent,
        MonitoringServicesFormComponent,
        MessageBoxComponent,
        MainContentContainerComponent,
        ListFilterCheckboxGroupComponent,
        GenericHeaderComponent,
        InfoBannerComponent,
        AlulaReceiversGroupAddComponent,
        AlulaReceiverInputComponent,
    ],
    providers: [RalinkDatabaseService, FirebaseDatabaseService],
})
export class SharedModule {}
